export const PREV = 'PREV'
export const NEXT = 'NEXT'
export const BREAK = 'BREAK'
